import { render } from "./CS_AIUX_process.vue?vue&type=template&id=64df84c6&scoped=true"
import script from "./CS_AIUX_process.vue?vue&type=script&lang=js"
export * from "./CS_AIUX_process.vue?vue&type=script&lang=js"

import "./CS_AIUX_process.vue?vue&type=style&index=0&id=64df84c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64df84c6"]])

export default __exports__